import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38ad8ded"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-loader" }
const _hoisted_2 = {
  key: 0,
  class: "no-filters-text"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "edit", -1))
const _hoisted_6 = {
  key: 0,
  class: "uk-icon-envelope-o"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_FilterModalMobileHeader = _resolveComponent("FilterModalMobileHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, {
      ref: "dropdown",
      left: "",
      modal: _ctx.tsMobileView
    }, {
      trigger: _withCtx(() => [
        _createVNode(_component_BaseButton, {
          secondary: "",
          muted: "",
          icon: "chevron-down"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" My Filters ")
          ], undefined, true),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["options", { 'ts-modal-c': _ctx.tsMobileView }])
        }, [
          (_ctx.tsMobileView)
            ? (_openBlock(), _createBlock(_component_FilterModalMobileHeader, {
                key: 0,
                title: "Saved Filters",
                onClose: _ctx.closeModal
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.hasFilters ? 'header' : 'no-filters-header')
          }, [
            (!_ctx.hasFilters)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " You have no saved filters "))
              : _createCommentVNode("", true),
            _createVNode(_component_BaseButton, {
              primary: "",
              full: "",
              click: _ctx.initSaveFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode("save current filter")
              ], undefined, true),
              _: 1
            }, 8, ["click"])
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSets, (filters, key) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: key,
              class: "option-set"
            }, [
              _createElementVNode("h5", null, _toDisplayString(key) + " filters", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters, (filter) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: filter.id,
                  class: "option"
                }, [
                  _createElementVNode("span", {
                    class: "filter-name",
                    onClick: () => _ctx.loadFilter(filter)
                  }, _toDisplayString(_ctx.getName(filter)), 9, _hoisted_3),
                  (!filter.locked)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "filter-edit",
                        onClick: () => _ctx.initEditFilter(filter.id)
                      }, [
                        _hoisted_5,
                        (_ctx.getDigestForFilter(filter.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ])), [
                  [_vShow, !filter.is_default]
                ])
              }), 128))
            ])), [
              [_vShow, filters.length > 0]
            ])
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["modal"])
  ]))
}